function clearLocationFields(next, name, value) {
  if (name === 'caseRegion') Object.assign(next, { detentionFacility: '', arrestingAgency: '', targetCourt: '' });
  if (name === 'inCustody' && value !== 'yes') next.detentionFacility = '';
}

function clearCaseFields(next, name, value) {
  if (name === 'bailStatus' && value !== 'set') next.bailAmount = '';
  if (name === 'noCourtDate' && value) next.nextCourtDate = '';
  if (name === 'primaryCharge' && value !== 'dui') next.documentsReady = next.documentsReady.filter(item => item !== 'dmv_notice');
}

function updateNames(next, current, name, value) {
  if (name === 'relationship') next.defendantName = value === 'self' ? current.contactName : current.relationship === 'self' ? '' : current.defendantName;
  if (name === 'contactName' && current.relationship === 'self') next.defendantName = value;
}

export function updateIntakeValue(current, name, value) {
  const next = { ...current, [name]: value };
  clearLocationFields(next, name, value);
  clearCaseFields(next, name, value);
  updateNames(next, current, name, value);
  return next;
}

export function buildIntakePayload(values) {
  return { ...values, formVersion: 'consolidated-v1',
    detentionFacility: values.inCustody === 'yes' ? values.detentionFacility : '',
    bailAmount: values.bailStatus === 'set' && values.bailAmount ? values.bailAmount : null,
    nextCourtDate: values.noCourtDate ? null : values.nextCourtDate || null,
  };
}